module.exports = __webpack_public_path__ + "img/portrait-060.ab6a1891.jpg";